import React, { useState, useEffect, useContext } from "react";
import { Title, Text } from "rizzui/typography";
import { Button, Input, Password, Textarea } from "rizzui";
import AccountBox from "../../component/accountBox";
import { Controller, useForm } from "react-hook-form";
import { passwordValidationPattern } from "./signup";
import { useNavigate } from "react-router";
import { AuthContext } from "../../context/authContext";
import {
  inputClassName,
  labelClassName,
  textAreaClassName,
} from "../projects/new/first";
import CountryDropdown from "../../component/countrySelect";

export default function CompleteSignUp() {
  useEffect(() => {
    document.title = "Complete your sign up";
  }, []);

  const {
    register,
    handleSubmit,
    formState: { errors },
    control,
  } = useForm({});

  const [isLoading, setIsLoading] = useState<boolean>(false);
  const navigate = useNavigate();

  const handleSignUp = handleSubmit((data) => {
    console.log(data);
    setIsLoading(true);
    setTimeout(navigate, 3000, "/dashboard");
  });

  return (
    <AccountBox>
      <div className="flex flex-col gap-[32px]">
        <div>
          <Title className="text-[18px] leading-[23.4px] font-[600] text-primary-dark mb-[8px] font-ibmPlexSerif">
            {" "}
            Create an account{" "}
          </Title>
          <Text className="text-[14px] leading-[18.48px] font-[400] text-secondary-dark font-switzer">
            Create an account to automate your sales with human-like AI phone
            conversations
          </Text>
        </div>

        <div className="text-secondary-dark font-switzer">
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleSignUp();
            }}
            noValidate
            className="flex flex-col gap-[24px]"
          >
            <Input
              type="text"
              label="Business Name"
              variant="text"
              rounded="md"
              inputClassName={inputClassName}
              labelClassName={labelClassName}
              labelWeight="normal"
              {...register("businessName", {
                required: {
                  value: true,
                  message: "Business name is required",
                },
              })}
              error={
                errors.businessName?.message
                  ? "" + errors.businessName.message
                  : ""
              }
            />

            <Textarea
              label="Tell us about your business"
              variant="outline"
              rounded="md"
              rows={3}
              textareaClassName={textAreaClassName}
              labelClassName={labelClassName}
              {...register("aboutBusiness", {
                required: {
                  value: true,
                  message: "Tell us about your business",
                },
              })}
              style={{ resize: "none" }}
              error={
                errors.aboutBusiness?.message
                  ? " " + errors.aboutBusiness.message
                  : ""
              }
            />

            <Controller
              control={control}
              name="businessCountry"
              rules={{
                required: {
                  value: true,
                  message: "Country of Business is Required",
                },
              }}
              render={({ field: { onChange, value, name } }) => (
                <div className="w-full">
                  <label className={labelClassName}>Country of Business</label>
                  <CountryDropdown
                    onChange={(code) => {
                      onChange({ code }); // Pass an object with the code
                    }}
                    value={value?.code} // Pass only the code
                    name={name}
                  />
                  {errors.businessCountry?.message && (
                    <p className="text-red text-[13px] mt-0.5 rizzui-textarea-error-text">
                      {"" + errors.businessCountry.message}
                    </p>
                  )}
                </div>
              )}
            />

            <Password
              label={<Text>Password</Text>}
              variant="text"
              rounded="md"
              labelWeight="normal"
              inputClassName={inputClassName}
              labelClassName={labelClassName}
              {...register("password", {
                ...passwordValidationPattern,
              })}
              error={
                errors.password?.message ? "" + errors.password.message : ""
              }
            />

            <Button
              variant="solid"
              className="bg-btn rounded-[4px] font-[500] text-[12px] leading-[15.84px] w-full mb-[32px]"
              type="submit"
              isLoading={isLoading}
            >
              Complete your sign up
            </Button>
          </form>
        </div>
      </div>
    </AccountBox>
  );
}
